import React from 'react';
import { formatPhoneNumber } from '../../../helper';

export default function AdminUserInfo(props) {
    let data = props.data;
    return <>
        <div className="inner-wrapper">
            <h3>User Info</h3>
            <div className="text-blk">
                <span className="label">
                    First Name:
                </span>
                <span className="value">
                    {data.first_name ? data.first_name : 'N/A'}
                </span>
            </div>
            <div className="text-blk">
                <span className="label">
                    Last Name:
                </span>
                <span className="value">
                    {data.last_name ? data.last_name : 'N/A'}
                </span>
            </div>
            <div className="text-blk">
                <span className="label">
                    Email:
                </span>
                <span className="value">
                    {data.email ? data.email : 'N/A'}
                </span>
            </div>
            <div className="text-blk">
                <span className="label">
                    Primary Phone:
                </span>
                <span className="value">
                    {data.cell_phone ? formatPhoneNumber(data.cell_phone) : 'N/A'}
                </span>
            </div>
            <div className="text-blk">
                <span className="label">
                    Secondary Phone:
                </span>
                <span className="value">
                    {data.secondary_phone ? formatPhoneNumber(data.secondary_phone) : 'N/A'}
                </span>
            </div>
            <div className="text-blk">
                <span className="label">
                    Account Locked:
                </span>
                <span className="value">
                    {!!data.account_locked ? 'True' : 'False'}
                </span>
                <span style={{
                    cursor: 'pointer',
                }} className="reset-link" onClick={() => props.openResetPasswordPopUp(true)}>Reset Password</span>
            </div>
        </div>
    </>
}